<template>
    <div class="theSideBar">



        <div class="logoWrapper">

            <img class="imgLogo" :src="require(`@/assets/logo_trans.png`)" />

        </div>



        <div class="mainMenuWrapper">



            <router-link class="linkStyle" :to="{ name: 'RingScreen' }">

                <div class="menuItemRow" :class="{ menuItemRowSelected: isRingScreenActive }">


                    <div class="iconArea">

                        <i class="bi bi-gem"></i>

                    </div>

                    <div class="labelArea">

                        <span style="float: left; margin-left: 0px;">Rings</span>

                    </div>

                </div>


            </router-link>


            <router-link class="linkStyle" :to="{ name: 'DressScreen' }">


                <div class="menuItemRow" :class="{ menuItemRowSelected: isDressScreenActive }">


                    <div class="iconArea">

                        <img width="20" :src="require(`@/assets/gown.png`)" />

                    </div>

                    <div class="labelArea">

                        <span style="float: left; margin-left: 0px;">Dresses</span>

                    </div>

                </div>




            </router-link>



            <div class="linkStyle" @click="cakeMessage">


                <div class="menuItemRow">


                    <div class="iconArea">

                        <img width="20" :src="require(`@/assets/cake.png`)" />

                    </div>

                    <div class="labelArea">

                        <span style="float: left; margin-left: 0px;">Cakes</span>

                    </div>

                </div>




            </div>



            <router-link class="linkStyle" :to="{ name: 'MyAccount' }">


                <div class="menuItemRow" :class="{ menuItemRowSelected: isMyAccountScreenActive }">


                    <div class="iconArea">

                        <i class="bi bi-gear"></i>

                    </div>

                    <div class="labelArea">

                        <span style="float: left; margin-left: 0px;">Account</span>

                    </div>

                </div>




            </router-link>


            <div class="menuItemRow" @click="authStore.logoutUser">


                <div class="iconArea">

                    <i class="bi bi-box-arrow-right"></i>

                </div>

                <div class="labelArea">

                    <span style="float: left; margin-left: 0px;">Logout</span>

                </div>

            </div>





        </div>





    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from "vue";
import { useAuthStore } from '@/stores/AuthStore';

const authStore = useAuthStore();

const route = useRoute();

const isDressScreenActive = computed(() => route.name === 'DressScreen');
const isRingScreenActive = computed(() => route.name === 'RingScreen');
const isMyAccountScreenActive = computed(() => route.name === 'MyAccount');


const cakeMessage = () => {
    alert('Cake image generation feature is coming soon!')
}




</script>

<style scoped>
.theSideBar {
    /* background-color: #f9f9f9; */
    width: 17%;
    overflow-y: auto;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);

}

.logoWrapper {
    display: flex;
    /* Enable Flexbox */
    align-items: center;
    /* Center items vertically */
    justify-content: center;
    /* Center items horizontally */
    width: 100%;
    height: 50px;
    padding-top: 20px;

    /* background-color: aqua; */
}

.imgLogo {
    width: 110px;
}


.mainMenuWrapper {
    /* background-color: aqua; */
    width: 100%;
    margin-top: 20px;
    /* padding: 20px; */
}

.menuItemRow {
    width: 100%;
    display: flex;
    cursor: pointer;
    padding: 20px;

}


.iconArea {
    /* background-color: #b8ffd3; */
    width: 10%;
    display: flex;
    align-items: center;
}

.labelArea {

    /* background-color: #36e1e1; */
    width: 80%;
    font-weight: 400;
    font-size: 15px;
    display: flex;
    align-items: center;

}


.menuItemRow:hover {
    background-color: rgb(232, 243, 234);
}

.menuItemRowSelected {
    background-color: rgb(232, 243, 234);
    width: 100%;
    display: flex;
    cursor: pointer;
    padding: 20px;
}

.linkStyle {
    text-decoration: none;
    color: inherit;
}
</style>